import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useCurrentUser } from "@modules/auth"
import { useTogglePreviewBuildFlagMutation } from "../queries.generated"
import {
  SiteDetailsPreviewBuildsEnabledFieldsFragment,
  SiteDetailsPreviewBuildsEnabledFieldsFragmentDoc,
} from "../fragments.generated"

export function useTogglePreviewBuilds(siteId: string) {
  const { currentUser } = useCurrentUser()

  const [
    togglePreviewBuildsMutation,
    { loading },
  ] = useTogglePreviewBuildFlagMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const togglePreviewBuilds = () => {
    setError(null)
    return togglePreviewBuildsMutation({
      variables: {
        siteId,
        userId: currentUser?.id,
      },
      update: (proxy, { data }) => {
        if (!data?.togglePreviewBuildFlag?.success) {
          return
        }

        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsPreviewBuildsEnabledFieldsFragmentDoc,
        }

        const site = proxy.readFragment<
          SiteDetailsPreviewBuildsEnabledFieldsFragment
        >(fragmentInfo)

        if (!site) {
          return
        }

        site.previewBuildsEnabled = !site.previewBuildsEnabled

        proxy.writeFragment<SiteDetailsPreviewBuildsEnabledFieldsFragment>({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        togglePreviewBuildFlag: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [togglePreviewBuilds, { loading, errorAlert }] as const
}
